import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationService, NotificationType } from './notification.service';
import { SharedRoutes } from '../../../constants';
import { HttpService } from './http.service';

@Injectable({
	providedIn: 'root'
})
export class PwaService {
	private newVersionSubject = new BehaviorSubject<boolean>(false);
	public newVersionAvailable$ = this.newVersionSubject.asObservable();

	constructor(
		private notification: NotificationService,
		private http: HttpService
	) {}

	handleNotification() {
		const text = 'نسخه جدید در دسترس است';
		this.notification.alert(text, NotificationType.warning, false, () => location.reload(), 'به‌روزرسانی');
		this.notification.notif({
			title: 'ایزی تریدر',
			body: text,
			defaultUrl: `/${SharedRoutes.MENU_ROUTE}`
		});
	}
	private reloadApplication() {
		window.location.reload();
	}

	private callForNewVersion() {
		this.newVersionSubject.next(true);
	}
}

export class MyVersion {
	date: Date;
	type;
	available?;
	current?;
	previous?;
}

export class AppConfig {
	showNewVersionNotify: boolean;
	reloadWhenNewVersionUploaded: boolean;
}
